"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeUnitMap = exports.getUnitType = exports.isImperial = exports.isMetric = exports.unitPluralToSingular = exports.unitMap = exports.convertibleUnitMap = void 0;
const unitVolumeMap_1 = require("./utils/unitVolumeMap");
const unitRows = [
    { single: "bunch", plural: "bunches" },
    { single: "bulb", plural: "bulbs" },
    { single: "bottle", plural: "bottles" },
    { single: "bag", plural: "bags" },
    { single: "batch", plural: "batches" },
    { single: "box", plural: "boxes" },
    { single: "cup", plural: "cups", other: [{ single: "c" }] },
    { single: "clove", plural: "cloves" },
    {
        single: "centimeter",
        plural: "centimeters",
        other: [{ single: "cm" }, { single: "centimetre", plural: "centimetres" }],
    },
    { single: "dozen", plural: "dozen" },
    { single: "dash", plural: "dashes" },
    {
        single: "deciliter",
        plural: "deciliters",
        other: [{ single: "dl" }, { single: "decilitre", plural: "decilitres" }],
    },
    { single: "ear", plural: "ears" },
    { single: "envelope", plural: "envelopes" },
    { single: "fillet", plural: "fillets" },
    {
        single: "fluid ounce",
        plural: "fluid ounces",
        other: [{ single: "fl oz" }],
    },
    {
        single: "gram",
        plural: "grams",
        other: [{ single: "g" }, { single: "gramme", plural: "grammes" }],
    },
    { single: "gallon", plural: "gallons", other: [{ single: "gal" }] },
    { single: "gill", plural: "gills" },
    { single: "head", plural: "heads" },
    { single: "handful", plural: "handfuls" },
    {
        single: "inch",
        plural: "inches",
        other: [{ single: "in" }, { single: '"' }],
    },
    { single: "jar", plural: "jars" },
    {
        single: "kilogram",
        plural: "kilograms",
        other: [{ single: "kg" }, { single: "kilogramme", plural: "kilogrammes" }],
    },
    { single: "loaf", plural: "loafs" },
    {
        single: "liter",
        plural: "liters",
        other: [{ single: "litre", plural: "litres" }, { single: "l" }],
    },
    {
        single: "milliliter",
        plural: "milliliters",
        other: [
            { single: "ml" },
            { single: "cc" },
            { single: "millilitre", plural: "millilitres" },
        ],
    },
    {
        single: "milligram",
        plural: "milligrams",
        other: [
            { single: "mg" },
            { single: "milligramme", plural: "milligrammes" },
        ],
    },
    {
        single: "meter",
        plural: "meters",
        other: [{ single: "m" }, { single: "metre", plural: "metres" }],
    },
    {
        single: "millimeter",
        plural: "millimeters",
        other: [{ single: "mm" }, { single: "millimetre", plural: "millimetres" }],
    },
    { single: "ounce", plural: "ounces", other: [{ single: "oz" }] },
    {
        single: "pound",
        plural: "pounds",
        other: [{ single: "lb", plural: "lbs" }],
    },
    { single: "pinch", plural: "pinches" },
    {
        single: "pint",
        plural: "pints",
        other: [{ single: "p" }, { single: "pt" }, { single: "fl pt" }],
    },
    { single: "piece", plural: "pieces" },
    { single: "package", plural: "packages" },
    {
        single: "quart",
        plural: "quarts",
        other: [
            { single: "q" },
            { single: "qt", plural: "qts" },
            { single: "fl qt" },
        ],
    },
    { single: "sprig", plural: "sprigs" },
    { single: "slice", plural: "slices" },
    { single: "stalk", plural: "stalks" },
    { single: "stick", plural: "sticks" },
    { single: "strip", plural: "strips" },
    {
        single: "tablespoon",
        plural: "tablespoons",
        other: [{ single: "tbl" }, { single: "tbsp", plural: "tbs" }],
    },
    { single: "teaspoon", plural: "teaspoons", other: [{ single: "tsp" }] },
    { single: "whole", plural: "whole" },
];
exports.convertibleUnitMap = {};
exports.unitMap = {};
unitRows.forEach(x => {
    const units = [
        x.single,
        x.plural,
        ...(x.other || [])
            .reduce((acc, y) => [...acc, y.single, y.plural], [])
            .filter(y => y),
    ].filter(y => y);
    if (x.single in unitVolumeMap_1.convertibleVolumes || x.single in unitVolumeMap_1.unitWeightMap) {
        units.forEach(u => {
            exports.convertibleUnitMap[u] = true;
            exports.unitMap[u] = true;
        });
    }
    else {
        units.forEach(u => {
            exports.unitMap[u] = true;
        });
    }
});
exports.unitPluralToSingular = fillUnitPluralToSingular({}, unitRows);
function fillUnitPluralToSingular(d, units) {
    if (units.length === 0) {
        return d;
    }
    const [first, ...rest] = units;
    if (first.plural) {
        d[first.plural] = first.single;
        if (first.other) {
            rest.push(...first.other);
        }
    }
    return fillUnitPluralToSingular(d, rest);
}
const imperialUnits = {
    cup: true,
    "fluid ounce": true,
    gallon: true,
    inch: true,
    ounce: true,
    pound: true,
    pint: true,
    quart: true,
};
const metricUnits = {
    centimeter: true,
    deciliter: true,
    gram: true,
    kilogram: true,
    liter: true,
    milliliter: true,
    milligram: true,
    meter: true,
    millimeter: true,
};
exports.isMetric = (s) => s in exports.normalizeUnitMap && exports.normalizeUnitMap[s] in metricUnits;
exports.isImperial = (s) => s in exports.normalizeUnitMap && exports.normalizeUnitMap[s] in imperialUnits;
exports.getUnitType = (s) => {
    if (exports.isImperial(s)) {
        return "imperial";
    }
    if (exports.isMetric(s)) {
        return "metric";
    }
    return "unknown";
};
exports.normalizeUnitMap = unitRows.reduce((acc, x) => {
    acc[x.single] = x.single;
    acc[x.plural] = x.single;
    if (x.other) {
        x.other.forEach(y => {
            acc[y.single] = x.single;
            if (y.plural) {
                acc[y.plural] = x.single;
            }
        });
    }
    return acc;
}, {});
//# sourceMappingURL=units.js.map